"use client";

import { useI18n } from "@/lib/i18n/I18nProvider";

/**
 * TreasuryFormMock — форма платёжной заявки с approval timeline
 */

export function TreasuryFormMock() {
  const { t } = useI18n();

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden shadow-lg border border-slate-200">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-50 to-white px-6 py-4 border-b border-slate-200">
        <h3 className="text-sm font-bold text-slate-900">
          {t("landing.mocks.treasury.title") || "Заявка на оплату PR-2026-0347"}
        </h3>
        <p className="text-xs text-slate-500 mt-1">
          {t("landing.mocks.treasury.createdAt") || "Инициирована 18 апреля 2026"}
        </p>
      </div>

      {/* Form fields (disabled style) */}
      <div className="p-6 space-y-4 bg-white">
        {/* Amount */}
        <div>
          <label className="text-xs font-semibold text-slate-600 block mb-1.5">
            {t("landing.mocks.treasury.amount") || "Сумма"}
          </label>
          <div className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5">
            <p className="text-sm font-mono font-semibold text-slate-900">
              {t("landing.mocks.treasury.amountValue") || "850 000 ₽"}
            </p>
          </div>
        </div>

        {/* Counterparty */}
        <div>
          <label className="text-xs font-semibold text-slate-600 block mb-1.5">
            {t("landing.mocks.treasury.counterparty") || "Контрагент"}
          </label>
          <div className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5">
            <p className="text-sm text-slate-900">
              {t("landing.mocks.treasury.counterpartyValue") || "ООО СтройСнаб"}
            </p>
          </div>
        </div>

        {/* Cost center */}
        <div>
          <label className="text-xs font-semibold text-slate-600 block mb-1.5">
            {t("landing.mocks.treasury.costCenter") || "Центр финансовой ответственности"}
          </label>
          <div className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5">
            <p className="text-sm text-slate-900">
              {t("landing.mocks.treasury.costCenterValue") || "Отель Москва Центр"}
            </p>
          </div>
        </div>

        {/* Purpose */}
        <div>
          <label className="text-xs font-semibold text-slate-600 block mb-1.5">
            {t("landing.mocks.treasury.purpose") || "Назначение платежа"}
          </label>
          <div className="bg-slate-50 border border-slate-200 rounded-lg px-3 py-2.5">
            <p className="text-sm text-slate-900">
              {t("landing.mocks.treasury.purposeValue") || "Оплата по договору №34"}
            </p>
          </div>
        </div>
      </div>

      {/* Approval timeline */}
      <div className="bg-slate-50 border-t border-slate-200 px-6 py-4">
        <p className="text-xs font-semibold text-slate-600 mb-3">
          {t("landing.mocks.treasury.approvalChain") || "Этапы согласования"}
        </p>
        <div className="flex items-center gap-2">
          {/* Initiator */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 rounded-full bg-keiro-green flex items-center justify-center">
              <span className="text-xs text-white font-bold">✓</span>
            </div>
            <p className="text-micro text-slate-600 mt-1.5 text-center w-16">
              {t("landing.mocks.treasury.roleInitiator") || "Инициатор"}
            </p>
          </div>

          {/* Arrow */}
          <div className="flex-1 h-0.5 bg-slate-300" />

          {/* Finance Director */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 rounded-full bg-amber-400 flex items-center justify-center">
              <span className="text-xs text-white font-bold">⏳</span>
            </div>
            <p className="text-micro text-slate-600 mt-1.5 text-center w-20">
              {t("landing.mocks.treasury.roleFinanceDirector") || "ФД Сети"}
            </p>
          </div>

          {/* Arrow */}
          <div className="flex-1 h-0.5 bg-slate-300" />

          {/* General Director */}
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 rounded-full bg-slate-400 flex items-center justify-center">
              <span className="text-xs text-white font-bold">⏸</span>
            </div>
            <p className="text-micro text-slate-600 mt-1.5 text-center w-20">
              {t("landing.mocks.treasury.roleGeneralDirector") || "Ген. директор"}
            </p>
          </div>
        </div>
      </div>

      {/* Demo label */}
      <div className="bg-white border-t border-slate-200 px-6 py-2 text-center">
        <p className="text-xs text-slate-500">
          {t("landing.mocks.treasury.demoLabel") || "Демо-режим · реальный UI продукта"}
        </p>
      </div>
    </div>
  );
}
